import { Link } from "react-router-dom";

type Props = {
  estado: boolean;
  clickState: (value: boolean) => void;
}

export const ViewButtons = ({ estado, clickState }: Props):JSX.Element => {
  return (
    <div className="ps-shopping__actions">
      <div className="ps-shopping__view">
        <p style={{ margin: "0 auto", marginRight: "1rem" }}>Vista</p>

        <ul className="ps-tab-list">
          <li className={estado ? "active" : ""}>
            <Link to="#" onClick={() => clickState(true)}>
              <i className={estado ? "icon-grid iconActivo" : "icon-grid"}></i>
            </Link>
          </li>
          <li className={!estado ? "active" : ""}>
            <Link to="#" onClick={() => clickState(false)}>
              <i
                className={
                  !estado ? "icon-list4 iconActivo" : "icon-list4"
                }></i>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
